import {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import {usePresentationParams} from './usePresentationParams';
import {REDIRECT_URI_KEY, REDIRECT_URI_QUERY} from '../constants';
import {normalizeRedirectUri} from '../util/url';

export const useCaptureRedirectUri = (): void => {
    const [searchParams] = useSearchParams();
    const {params} = usePresentationParams();
    const redirectUri = searchParams.get(REDIRECT_URI_QUERY) ?? params[REDIRECT_URI_QUERY];

    useEffect(() => {
        const normalizedUri = redirectUri ? normalizeRedirectUri(redirectUri) : null;
        if (normalizedUri) {
            sessionStorage.setItem(REDIRECT_URI_KEY, normalizedUri);
        } else {
            sessionStorage.removeItem(REDIRECT_URI_KEY);
        }
    }, [redirectUri]);
};
